import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import {
  MatTableDataSource,
  MatTableDataSourcePageEvent,
} from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'fury-customer-agreement-details',
  templateUrl: './customer-agreement-details.component.html',
  styleUrls: ['./customer-agreement-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CustomerAgreementDetailsComponent implements OnInit {
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  displayedColumns: string[] = [
    'agreementNumber',
    'agreementVersion',
    'firstName',
    'lastName',
    'total_amount',
    'action',
  ];
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  id!: any;
  pdfData: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  constructor(
    private api: ApiService,
    private activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.id = this.activeRoute.snapshot.paramMap.get('id');
    if (this.id) {
      this.getCustomerAgreement();
    }
    this.activeRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;   
    });
  }

  ngOnInit(): void {}

  getCustomerAgreement() {
    this.api
      .get(
        `admin/customer-agreement/get-customer-agreement-versions/${
          this.id
        }?page=${this.pageIndex + 1}&size=${this.pageSize}${
          this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
        }`
      )
      .subscribe((res: any) => {
        if (res.body) {
          this.itemList = res.body?.customerAgreements?.data;
          this.dataSource = res.body?.customerAgreements?.data;
          this.totalCount = res.body?.customerAgreements?.total;
          this.cdr.detectChanges();
          if (this.itemList) {
            this.getAgreementData(this.itemList[0]?.customerAgreementVersionId);
          }
        }
      });
  }

  
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/customer-agreement/customer-detail/${this.id}?page=${this.pageIndex + 1}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}`
    );
    this.getCustomerAgreement();
  }
  getAgreementData(id: string) {
   
    this.api
      .get(`admin/customer-agreement/get-customer-agreement/${id}`)
      .subscribe((res: any) => {
        if (res.body?.customerAgreement) {
          this.pdfData = {...res.body?.customerAgreement,
            coverSystems: res.body?.customerAgreement?.mainPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'systems'
            }),
            coverAppliances: res.body?.customerAgreement?.mainPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'appliances'
            }),
            optionalCoverSystems:  res.body?.customerAgreement?.optionalPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'systems'
            }),
            optionalCoverAppliances:  res.body?.customerAgreement?.optionalPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'appliances'
            }),
          }
        }
      });
  }

}
